function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.87,
  d: "M17-4v24H-7V-4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.41 14.59L1.83 16 5 12.83 8.17 16l1.41-1.41L5 10 .41 14.59zM9.59 1.41L8.17 0 5 3.17 1.83 0 .41 1.41 5 6l4.59-4.59z",
  fill: "#FFF"
}));

function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16
  }, props), _ref);
}

export default SvgCollapse;